import type { AppState } from 'state/state.model';

import type { TabsOrderType } from './tabOrder.model';

function selectTabOrderState(state: AppState): Exclude<TabsOrderType, null | undefined> {
  return (
    state.userPreferences.tabsOrder ?? {
      spmVisible: [],
      spmHidden: [],
    }
  );
}

export function getSpmVisibleTabs(state: AppState) {
  return selectTabOrderState(state).spmVisible;
}
export function getSpmHiddenTabs(state: AppState) {
  return selectTabOrderState(state).spmHidden;
}
